var exports = {
  "kL": "container__tk5zis",
  "f6": "modPressed__ekbRvJ",
  "jY": "isDraggedOver__vTo8oQ",
  "P": "editorWrapper__MetgRR",
  "UM": "skeletonOverlay__9JvjoA",
  "k4": "generatingText__FiOe62",
};

module.exports = exports;
